export default {
    reCAPTCHASiteKey: '6LeCSRIaAAAAACxmt6-lvJ3Yln3Ujh7DDAJfNm5h',
};
